import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  NumberInput,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { sky_blue } from "../../../../../const/variables";

const ModalItemPrimaryDiscountToAll = ({
  appleDiscountToAll,
  itemType,
  typePromotion,
}: {
  appleDiscountToAll: (dataSubmit: any) => void;
  itemType?: string;
  typePromotion: string;
}) => {
  const entity: {
    discountPercent: number | null;
    discountAmount: number | null;
    quantityMin: number | null;
    quantityMax: number | null;
    quantityApply: number | null;
    attribute1: string | null;
    attribute4: string | null;
    price: number | null;
    attribute6: string | null;
  } = {
    discountPercent: null,
    discountAmount: null,
    quantityMin: null,
    quantityMax: null,
    quantityApply: null,
    attribute1: null,
    attribute4: null,
    price: null,
    attribute6: null,
  };

  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {
      quantityMax: (value, values) => {
        if (value && values.quantityMin && value < values.quantityMin) {
          return "Số lượng tối đa không được nhỏ hơn số lượng tối thiểu";
        }
      },
      quantityMin: (value, values) => {
        if (value && values.quantityMax && value > values.quantityMax) {
          return "Số lượng tối đa không được nhỏ hơn số lượng tối thiểu";
        }
      },
    },
  });

  return (
    <div>
      <Box
        component="form"
        onSubmit={form.onSubmit((e) => {
          appleDiscountToAll(e);
        })}
      >
        {itemType !== "gift" && (
          <Grid mt="md">
            {typePromotion && typePromotion === "1" ? (
              <Grid.Col span={itemType === "primary" ? 4 : 6}>
                <TextInput
                  label={"% chiết khấu"}
                  placeholder={"Nhập %"}
                  type="number"
                  disabled={!!form.values.discountAmount || !!form.values.price}
                  {...form.getInputProps("discountPercent")}
                />
              </Grid.Col>
            ) : (
              <></>
            )}
            <Grid.Col
              span={itemType === "primary" && typePromotion === "1" ? 4 : 6}
            >
              {/* <TextInput
              label={"Số tiền chiết khẩu"}
              placeholder={"Nhập số tiền"}
              type="number"
              disabled={!!form.values.discountPercent}
              {...form.getInputProps("discountAmount")}
            /> */}
              <NumberInput
                label={"Số tiền chiết khấu"}
                placeholder={"Nhập số tiền"}
                hideControls
                thousandSeparator="."
                decimalSeparator=","
                allowNegative={false}
                disabled={
                  typePromotion && typePromotion === "1"
                    ? !!form.values.discountPercent || !!form.values.price
                    : !!form.values.price
                }
                {...form.getInputProps("discountAmount")}
                onChange={(e) => {
                  form.getInputProps("discountAmount").onChange(e);
                }}
              />
            </Grid.Col>
            {itemType === "primary" ? (
              <Grid.Col
                span={itemType === "primary" && typePromotion === "1" ? 4 : 6}
              >
                <NumberInput
                  label="Giá tiền áp dụng trong CTKM"
                  placeholder="Nhập giá tiền"
                  hideControls
                  thousandSeparator="."
                  allowNegative={false}
                  decimalSeparator=","
                  disabled={
                    typePromotion && typePromotion === "1"
                      ? !!form.values.discountAmount ||
                        !!form.values.discountPercent
                      : !!form.values.discountAmount
                  }
                  {...form.getInputProps("price")}
                />
              </Grid.Col>
            ) : (
              <></>
            )}
          </Grid>
        )}

        <Grid mt="md">
          <Grid.Col span={itemType !== "addOn" ? 4 : 6}>
            <NumberInput
              label={"Số Lượng tối thiểu"}
              placeholder={"Nhập số lượng"}
              hideControls
              {...form.getInputProps("quantityMin")}
            />
          </Grid.Col>
          <Grid.Col span={itemType !== "addOn" ? 4 : 6}>
            <NumberInput
              label={"Số Lượng tối đa"}
              placeholder={"Nhập số lượng"}
              hideControls
              {...form.getInputProps("quantityMax")}
            />
          </Grid.Col>
          {itemType !== "primary" ? (
            <Grid.Col span={itemType !== "addOn" ? 4 : 6}>
              <TextInput
                label={"Số Lượng áp dụng"}
                placeholder={"Nhập số lượng"}
                type="number"
                {...form.getInputProps("quantityApply")}
              />
            </Grid.Col>
          ) : (
            <Grid.Col span={4}>
              <TextInput
                label={"Số lượng áp dụng"}
                placeholder={"Nhập số lượng"}
                type="number"
                {...form.getInputProps("attribute3")}
              />
            </Grid.Col>
          )}
        </Grid>

        {itemType !== "gift" && (
          <Grid mt="md">
            {itemType === "primary" ? (
              <>
                <Grid.Col span={4}>
                  <NumberInput
                    label="Hãng/NCC tài trợ"
                    placeholder="Nhập số tiền"
                    hideControls
                    thousandSeparator="."
                    decimalSeparator=","
                    {...form.getInputProps("attribute6")}
                  />
                </Grid.Col>
                <Grid.Col span={4}>
                  <Checkbox
                    mt={30}
                    label="Nổi bật"
                    checked={form.getValues()?.attribute4 === "Y"}
                    onClick={() =>
                      form.setValues((prev) => ({
                        ...prev,
                        attribute4:
                          form.getValues()?.attribute4 === "Y" ? "N" : "Y",
                      }))
                    }
                  />
                </Grid.Col>
              </>
            ) : (
              <></>
            )}
          </Grid>
        )}

        {/* {itemType === "gift" ? (
          <Grid>
            <Grid.Col span={12}>
              <Textarea
                label={"Lưu ý thêm"}
                placeholder={"Nhập Lưu ý thêm"}
                autosize
                minRows={4}
                {...form.getInputProps("attribute1")}
              />
            </Grid.Col>
          </Grid>
        ) : (
          <></>
        )} */}

        <Group justify="end" mt="md">
          <Button
            type="button"
            color="gray"
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={<IconWindow size={18} />}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            leftSection={<IconCheck size={18} />}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </div>
  );
};

export default ModalItemPrimaryDiscountToAll;
